<div class="tooltip-item">
  <mat-icon class="material-icons-outlined">insert_drive_file</mat-icon>
  <strong>{{ 'data_sources.custom_imports.file_name' | translate }}:</strong>
  <span>{{ customImport.payload.relationships.custom_import_configuration.data.attributes.parameters.original_file_name }}</span>
</div>
<div class="tooltip-item">
  <mat-icon class="material-icons-outlined">description</mat-icon>
  <strong>{{ 'data_sources.custom_imports.file_type' | translate }}:</strong>
  <span>{{ customImport.payload.relationships.custom_import_configuration.data.attributes.file_type }}</span>
</div>
<div class="tooltip-item"
     *ngIf="customImport.payload.relationships.custom_import_configuration.data.attributes.parameters.file_separator">
  <mat-icon class="material-icons-outlined">text_snippet</mat-icon>
  <strong>{{ 'data_sources.custom_imports.file_separator' | translate }}:</strong>
  <span>{{ customImport.payload.relationships.custom_import_configuration.data.attributes.parameters.file_separator }}</span>
</div>
<div class="tooltip-item">
  <mat-icon class="material-icons-outlined">analytics</mat-icon>
  <strong>{{ 'data_sources.dimensions' | translate }} ({{ customImport.nbDimensions$ | async }}):</strong>
</div>
<div class="variables-container">
  <app-source [item]="dimension.item$.value.payload"
              *ngFor="let dimension of customImport.dimensions$ | async"
              [enableName]="false">
    <div class="display-flex flex-align-baseline gap-0-5em overflow-hidden">
      <strong class="text-ellipsis">{{ dimension.item$.value.payload.attributes.name }}</strong>
      <small class="display-flex flex-align-center gap-0-5em text-ellipsis">
        (<span>{{ 'data_sources.custom_imports.column' | translate }} {{ dimension.payload.ext_name }}</span>)
      </small>
    </div>
  </app-source>
</div>
<div class="tooltip-item">
  <mat-icon class="material-icons-outlined">analytics</mat-icon>
  <strong>{{ 'data_sources.metrics' | translate }} ({{ customImport.nbMetrics$ | async }}):</strong>
</div>
<div class="variables-container">
  <app-source [item]="metric.item$.value.payload"
              *ngFor="let metric of customImport.metrics$ | async"
              [enableName]="false">
    <div class="display-flex flex-align-baseline gap-0-5em overflow-hidden">
      <strong class="text-ellipsis">{{ metric.item$.value.payload.attributes.name }}</strong>
      <small class="display-flex flex-align-center gap-0-5em text-ellipsis">
        (
          <span>{{ 'data_sources.custom_imports.column' | translate }} {{ metric.payload.ext_name }},</span>
          <span>{{ 'data_sources.custom_imports.format' | translate }} {{ metric.item$.value.payload.attributes.format_type }}</span>
        )
      </small>
    </div>
  </app-source>
</div>
<div class="tooltip-item">
  <mat-icon class="material-icons-outlined">event</mat-icon>
  <strong>{{ 'data_sources.custom_imports.date_mode' | translate }}:</strong>
  <span>{{ customImport.payload.relationships.custom_import_configuration.data.attributes.date_mode }}</span>
</div>
<div class="tooltip-item">
  <mat-icon class="material-icons-outlined">edit_calendar</mat-icon>
  <strong>{{ 'data_sources.custom_imports.date_format' | translate }}:</strong>
  <span>{{ customImport.date_format$ | async }}</span>
</div>
<div class="tooltip-item">
  <mat-icon class="material-icons-outlined">table_rows</mat-icon>
  <strong>{{ 'data_sources.custom_imports.header_line' | translate }}:</strong>
  <span>{{ customImport.payload.relationships.custom_import_configuration.data.attributes.parameters.headers_line }}</span>
</div>
<div class="tooltip-item">
  <mat-icon class="material-icons-outlined">add</mat-icon>
  <strong>{{ 'data_sources.custom_imports.total' | translate }}:</strong>
  <span>{{ customImport.payload.relationships.custom_import_configuration.data.attributes.parameters.reject_last_row }}</span>
</div>
<div class="tooltip-item">
  <mat-icon class="material-icons-outlined">format_list_numbered</mat-icon>
  <strong>{{ 'data_sources.custom_imports.sheet' | translate }}:</strong>
  <span>{{ customImport.payload.relationships.custom_import_configuration.data.attributes.parameters.sheet }}</span>
</div>
<div class="tooltip-item">
  <mat-icon class="material-icons-outlined">monetization_on</mat-icon>
  <strong>{{ 'data_sources.custom_imports.currency' | translate }}:</strong>
  <span>{{ customImport.payload.relationships.custom_import_configuration.data.attributes.parameters.currency }}</span>
</div>
<div class="tooltip-item">
  <mat-icon class="material-icons-outlined">note_add</mat-icon>
  <strong>{{ 'data_sources.custom_imports.aggregation_type' | translate }}:</strong>
  <span>{{ customImport.payload.attributes.aggregation_type }}</span>
</div>
